import { render } from "./MonacoEditorRead.vue?vue&type=template&id=137490b0&ts=true"
import script from "./MonacoEditorRead.vue?vue&type=script&lang=ts"
export * from "./MonacoEditorRead.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__